const languages: {
  [key: string]: { value: string; text: string; abbreviatedText: string; englishText: string; langAttribute: string };
} = {
  fr: {
    value: 'fr',
    text: 'Français',
    abbreviatedText: 'FR',
    englishText: 'French',
    langAttribute: 'fr',
  },
  en: {
    value: 'en',
    text: 'English',
    abbreviatedText: 'EN',
    englishText: 'English',
    langAttribute: 'en',
  },
  es: {
    value: 'es',
    text: 'Español',
    abbreviatedText: 'ES',
    englishText: 'Spanish',
    langAttribute: 'es',
  },
  'zh-CN': {
    value: 'zh-CN',
    text: '简体中文',
    abbreviatedText: '简体中文',
    englishText: 'Simplified Chinese',
    langAttribute: 'zh-Hans',
  },
  'pt-BR': {
    value: 'pt-BR',
    text: 'Português',
    abbreviatedText: 'Português',
    englishText: 'Portuguese',
    langAttribute: 'pt',
  },
  de: {
    value: 'de',
    text: 'Deutsch',
    abbreviatedText: 'Deutsch',
    englishText: 'German',
    langAttribute: 'de',
  },
  ru: {
    value: 'ru',
    text: 'Русский',
    abbreviatedText: 'Русский',
    englishText: 'Russian',
    langAttribute: 'ru',
  },
  'fr-CA': {
    value: 'fr-CA',
    text: 'Français (Canada)',
    abbreviatedText: 'Français (Canada)',
    englishText: 'French (Canada)',
    langAttribute: 'fr-CA',
  },
  'zh-TW': {
    value: 'zh-TW',
    text: '繁體中文',
    abbreviatedText: '繁體中文',
    englishText: 'Traditional Chinese',
    langAttribute: 'zh-HK',
  },
  it: {
    value: 'it',
    text: 'Italiano',
    abbreviatedText: 'Italiano',
    englishText: 'Italian',
    langAttribute: 'it',
  },
  tr: {
    value: 'tr',
    text: 'Türkçe',
    abbreviatedText: 'Türkçe',
    englishText: 'Turkish',
    langAttribute: 'tr',
  },
  ko: {
    value: 'ko',
    text: '한국어',
    abbreviatedText: '한국어',
    englishText: 'Korean',
    langAttribute: 'ko',
  },
  ja: {
    value: 'ja',
    text: '日本語',
    abbreviatedText: '日本語',
    englishText: 'Japanese',
    langAttribute: 'ja',
  },
  ro: {
    value: 'ro',
    text: 'Română',
    abbreviatedText: 'Română',
    englishText: 'Romanian',
    langAttribute: 'ro',
  },
  sv: {
    value: 'sv',
    text: 'Svenska',
    abbreviatedText: 'Svenska',
    englishText: 'Swedish',
    langAttribute: 'sv',
  },
  hu: {
    value: 'hu',
    text: 'Magyar',
    abbreviatedText: 'Magyar',
    englishText: 'Hungarian',
    langAttribute: 'hu',
  },
  cs: {
    value: 'cs',
    text: 'Čeština',
    abbreviatedText: 'Čeština',
    englishText: 'Czech',
    langAttribute: 'cs',
  },
  hr: {
    value: 'hr',
    text: 'Hrvatski',
    abbreviatedText: 'Hrvatski',
    englishText: 'Croatian',
    langAttribute: 'hr',
  },
  pl: {
    value: 'pl',
    text: 'Polski',
    abbreviatedText: 'Polski',
    englishText: 'Polish',
    langAttribute: 'pl',
  },
  nl: {
    value: 'nl',
    text: 'Nederlands',
    abbreviatedText: 'Nederlands',
    englishText: 'Dutch',
    langAttribute: 'nl',
  },
};

export default languages;
